module.exports = __webpack_public_path__ + "img/confluence.213773fc.svg";